import { render, staticRenderFns } from "./CSSCheckIcon.vue?vue&type=template&id=470049b6&"
import script from "./CSSCheckIcon.vue?vue&type=script&lang=ts&"
export * from "./CSSCheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports